const userKey = "user";
const tokenKey = "super-admin-socket-token";
const settingsKey = "settings";

export const setUserInLocalStorage = (user) => {
  localStorage.setItem(userKey, JSON.stringify(user));
};

export const getUserFromLocalStorage = () => {
  const user = localStorage.getItem(userKey);
  if (user) {
    return JSON.parse(user);
  }
  return null;
};

export const setTokenInLocalStorage = (token) => {
  localStorage.setItem(tokenKey, token);
};

export const getTokenFromLocalStorage = () => {
  const token = localStorage.getItem(tokenKey);
  return token || null;
};

export const getViewedFeatureAnnouncementsFromLocalStorage= (): string[] | null => {
  const jsonObject = localStorage.getItem('viewedFeatureAnnouncements');
  if (jsonObject) {
    return JSON.parse(jsonObject);
  }
  return null;
}

export const setViewedFeatureAnnouncementsInLocalStorage = (versions: string[]) => {
  let viewedFeatureAnnouncements = getViewedFeatureAnnouncementsFromLocalStorage() || [];
  viewedFeatureAnnouncements = viewedFeatureAnnouncements.concat(versions);
  localStorage.setItem('viewedFeatureAnnouncements', JSON.stringify(viewedFeatureAnnouncements));
}

export const getNotificationSettingsFromLocalStorage= (): any | null => {
  const jsonObject = localStorage.getItem('notificationSettings');
  if (jsonObject) {
    return JSON.parse(jsonObject);
  }
  return null;
}

export const setNotificationSettingsInLocalStorage = (notificationSettings: object) => {
  localStorage.setItem('notificationSettings', JSON.stringify(notificationSettings));
}

export const clearLocalStorage = () => {
  localStorage.removeItem(userKey);
  localStorage.removeItem(tokenKey);
};

export const setSettingsInLocalStorage = (settings) => {
  localStorage.setItem(settingsKey, JSON.stringify(settings));
};

export const getSettingsFromLocalStorage = () => {
  const settings = localStorage.getItem(settingsKey);

  if (settings) {
    return JSON.parse(settings);
  }

  return {};
};
